import { render, staticRenderFns } from "./proven-benefits.vue?vue&type=template&id=737d46d2"
import script from "./proven-benefits.vue?vue&type=script&lang=js"
export * from "./proven-benefits.vue?vue&type=script&lang=js"
import style0 from "./proven-benefits.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports